import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@softline/ui-core';

/** The roster's event card: a coloured bar, a tinted header with title and status
    icon, and a time/duration line. Rosters pick the colours per event type; the
    header projects `[rosterCardBadge]` (in place of the icon) and `[rosterCardActions]`;
    `[rosterCardMeta]` sits before the duration, `[rosterCardDetails]` shows only expanded. */
@Component({
  selector: 'soft-roster-event-card',
  templateUrl: './roster-event-card.component.html',
  styleUrl: './roster-event-card.component.css',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RosterEventCardComponent {
  readonly title = input.required<string>();
  readonly titleItalic = input(false);
  readonly subtitle = input<string | null>(null);
  readonly description = input<string | null>(null);
  readonly timeLabel = input<string | null>(null);
  readonly durationLabel = input<string | null>(null);
  readonly tooltip = input<string | null>(null);
  readonly compact = input(false);
  readonly icon = input<string | null>(null);
  readonly barClass = input('bg-surface-quaternary');
  readonly headerClass = input('bg-surface');
  readonly iconClass = input('');
  readonly frameClass = input('');
}
